import { Button, Stack } from '@mui/material';
import { PropsWithChildren, ReactNode } from 'react';
import MBModal from './MBModal';

interface Props {
  title: string;
  confirmText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  onClose: () => void;
  open: boolean;
  isDisabled?: boolean;
  isLoading?: boolean;
  contextText?: string | ReactNode;
}

const DoubleConfirmModal = ({
  title,
  children,
  onConfirm,
  confirmText = 'Confirm',
  onCancel,
  onClose,
  open,
  isDisabled,
  isLoading,
  contextText,
}: PropsWithChildren<Props>) => {
  return (
    <MBModal
      open={open}
      title={title}
      onClose={onClose}
      isLoading={isLoading}
      disableClose={isLoading}
      contentText={contextText}
      actions={
        <Stack direction={'row'} gap={1} justifyContent={'end'} p={2}>
          <Button
            variant='contained'
            onClick={onConfirm}
            disabled={isDisabled}
            color='error'
          >
            {confirmText}
          </Button>
          <Button variant='text' onClick={onCancel} disabled={isDisabled}>
            Cancel
          </Button>
        </Stack>
      }
    >
      {children}
    </MBModal>
  );
};

export default DoubleConfirmModal;
